<template>
  <div>
    <span id="disabled-wrapper">
      <b-button v-if="!propPedido"
                id="addItens"
                v-b-modal.novoLancamento
                class="mt-4 p-2 pl-3 pr-3 w-100"
                variant="outline-primary"
                :disabled="caixaStore.aberto === 0"
                @click="openModal">
        <IconSvg class="icon-add-new"
                 icon="add" />
        Novo Lançamento
      </b-button>
    </span>
    <b-tooltip v-if="caixaStore.aberto === 0"
               target="disabled-wrapper"
               triggers="hover">
      É necessário abrir o caixa para poder criar lançamentos
    </b-tooltip>
    <button v-if="propPedido"
            v-b-modal.novoLancamento
            type="button"
            class="btn btn-secondary">
      Editar Lançamento
    </button>
    <b-modal id="novoLancamento"
             centered
             size="xl"
             title="Novos Lançamentos"
             header-bg-variant="secondary"
             header-text-variant="white">
      <form class="p-3">
        <section class="row">
          <div class="col-3">
            <b-form-group label="Data de lançamento"
                          label-for="Data de Lançamento"
                          class="mb-0" />
            <b-form-input
              id="Data de Lançamento"
              v-model="novoLancamento.data_lancamento"
              required
              :disabled="novoLancamento.tipo_lancamento === null "
              type="date" />
          </div>
          <div class="ml-4">
            <b-form-group label="Tipo de lançamento"
                          label-for="Tipo de Lançamento"
                          class="mb-0"
                          required />
            <b-radio-group id="Tipo de Lançamento"
                           v-model="novoLancamento.tipo_lancamento"
                           disabled-field="notEnabled" />
            <b-form-radio v-model="novoLancamento.tipo_lancamento"
                          class="ml-3 d-inline p-2"
                          :disabled="propPedido && propPedido.lancamentosAvulso.tipo ==='receita'"
                          value="despesa"                          
                          :checked="novoLancamento.tipo_lancamento === 'despesa'">
              Despesa
            </b-form-radio>
            <b-form-radio v-model="novoLancamento.tipo_lancamento"
                          class="ml-4 d-inline p-2"
                          value="receita"
                          :disabled="propPedido && propPedido.lancamentosAvulso.tipo ==='despesa'"
                          :checked="novoLancamento.tipo_lancamento === 'receita'">
              Receita
            </b-form-radio>          
          </div>
        </section>
        <section class="d-flex row mt-4">
          <div v-if="novoLancamento.tipo_lancamento != 'receita'"
               class="col-5">
            <b-form-group label="Beneficiario"
                          label-for="Beneficiario"
                          class="mb-0" />
            <b-form-input
              id="Beneficiario"
              v-model="novoLancamento.beneficiario"
              :disabled="novoLancamento.tipo_lancamento === null " />
          </div>
          <div v-if="novoLancamento.tipo_lancamento == 'receita'" 
               class="col-5">
            <b-form-group label="Ato"
                          label-for="ato"
                          class="mb-0" />
            <b-form-input
              id="ato"
              v-model="novoLancamento.ato"
              :disabled="novoLancamento.tipo_lancamento === null " />
          </div>
          <div class="col-6">
            <b-form-group label="Detalhamento"
                          label-for="Detalhamento"
                          class="mb-0" />
            <b-form-input
              id="Detalhamento"
              v-model="novoLancamento.detalhamento"
              :disabled="novoLancamento.tipo_lancamento === null " />
          </div>
          <div v-if="!propPedido"
               class="ml-3 mt-3">
            <div class="d-flex">
              <label for="valor-total-lancamento">Valor Total</label>
              <span class="ml-1 label-obrigatoria">(obrigatório)</span>
            </div>
            <b-form-input id="valor-total-lancamento"
                          v-model="novoLancamento.valor_total"
                          v-money="money"
                          maxlength="16"
                          required
                          :disabled="novoLancamento.tipo_lancamento === null " />
          </div>   
        </section>        
        <div v-if="!propPedido" 
             class="mt-4">
          <b-form-group v-show="novoLancamento.tipo_lancamento === 'receita'"
                        label="Forma de pagamento"
                        label-for="forma-pg-lancamento"
                        class="mb-0" />
          <b-radio-group v-show="novoLancamento.tipo_lancamento === 'receita'"
                         id="forma-pg-lancamento"
                         v-model="novoLancamento.forma_pg"
                         :options="formasPg"
                         value-field="item"
                         text-field="name" />  
        </div>
      </form>
      <DropZone v-if="!propPedido"
                @files="getFiles" />
      <template v-slot:modal-footer="{ close }">
        <b-button variant="light"
                  @click="() => {
                    resetForm()
                    close()
                  }">
          Voltar
        </b-button>
        <b-button v-if="!propPedido"
                  :disabled="novoLancamento.valor_total === 'R$ 0,00' || null || btnSalvar"
                  @click="modalConfirmcao()">
          Salvar item
        </b-button>
        <b-button v-if="propPedido"
                  @click="editarLancamento()">
          Editar item
        </b-button>
      </template>
    </b-modal>
    <div>
      <b-modal id="bv-modal-confirmacao-1"
               hide-footer
               hide-header
               centered
               size="lg">
        <div class="d-block text-left bv-modal-confirmacao">
          Deseja confirmar o lançamento de item sem a opção de pagamento?
          O item será listado em pendentes, enquanto ficar sem opção definida.
        </div>
        <div class="d-flex justify-content-center">
          <b-button class="mt-3 mr-3 botao-modal"
                    variant="danger"
                    @click="modalConfirmacaoNao">
            Não
          </b-button>
          <b-button class="mt-3 ml-3 botao-modal"
                    @click="salvarLancamento">
            Sim
          </b-button>          
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>

  // Imports
  import { VMoney } from 'v-money'
  import moment from 'moment'
  import { moneyToNumber } from '../../../../utils/conversors'

  // Services
  import lancamentoService from '../lancamentoService'
  import pedidoService from '../pedidoService'
  import pagamentoService from '../pagamentoService'

  // Components
  import DropZone from '../../DropZone.vue'

  export default ({
    nome: "NovosLancamento",
    directives: {
      money: VMoney
    },
    components: {
      DropZone,
    },
    props: {
      propPedido: {type: Object, default: null}
    },
    data () {
      return {
        novoLancamento: {
          data_lancamento: moment().format('YYYY-MM-DD'),
          tipo_lancamento: null,
          forma_pg: null,
          tipo_pg: 'A vista',
          detalhamento: null,
          atos: null,
          valor_total: null,
          status_pg: 'pendente',
          id_pedido: null,
          caixaId: null,
          files: [],
          // Receita
          ato: null,
          // Despesa
          beneficiario: null,
        },
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },
        formasPg: [
          {item: "Dinheiro", name: "Dinheiro"},
          {item: "Cartão de Debito", name: "Cartão de Debito"},
          {item: "Cartão de Crédito", name: "Cartão de Crédito"},
          {item: "Pix", name: "PIX"},
          {item: "Cheque", name: "Cheque"},
          {item: "Outros", name: "Outros"},      
        ],
        tipoPg: [
          {item: "A vista", name: "A vista"},
          {item: "Parcelado", name: "Parcelado"},   
        ],
        btnSalvar: false
      }
    },
    computed: {
      cxData () {
        return this.$store.state.frenteCaixa.cxData
      },
      CxatualizarPedidos () {
        // Boolean - serve apenas para atualizar lista e saldo sempre que valor muda true/false
        return this.$store.state.frenteCaixa.atualizarPedidos
      },
      caixaStore () {
        return this.$store.state.frenteCaixa.caixa
      },
    },
    watch: {
      caixaStore () {
        this.novoLancamento.caixaId = this.caixaStore.caixa_id
      },
    },
    created () {
      if (this.propPedido) {
        this.novoLancamento.data_lancamento = moment(this.propPedido.data_lancamento).format('YYYY-MM-DD')
        this.novoLancamento.tipo_lancamento = this.propPedido.lancamentosAvulso.tipo
        this.novoLancamento.ato = this.propPedido.lancamentosAvulso.ato
        this.novoLancamento.detalhamento = this.propPedido.lancamentosAvulso.detalhamento
        this.novoLancamento.valor_total = this.propPedido.lancamentosAvulso.valor_total
        this.novoLancamento.beneficiario = this.propPedido.lancamentosAvulso.beneficiario
      }
      this.novoLancamento.caixaId = this.caixaStore.caixa_id
    },
    methods: {
      formatNames (files) {
        return files.length === 1 ? files[0].name : `${files.length} files selected`
      },
      async criarPedido () {
        try {
          const payload = {
            num_selo: 's/ selo',
            pagamento: null,
            solicitante: '---',
            data_lancamento: this.novoLancamento.data_lancamento,
            status_pg: this.novoLancamento.status_pg,
            tipo_pedido: 'Avulso',
            valor: this.novoLancamento.valor_total,
            caixa_id: this.caixaStore.caixa_id
          }
          const pedido = await pedidoService.storePedido(payload)
          this.novoLancamento.id_pedido = pedido.cx_pedido_id
          this.novoLancamento.caixaId = pedido.caixa_id
        } catch (err) {
          displayMessage('error', 'Erro!', err.message)
        }
      },
      async criarLancamento () { 
        try {
          this.novoLancamento.caixaId = this.caixaStore.caixa_id
          const lancamento = await lancamentoService.storeLancamento(this.novoLancamento)
          // salvo os arquivos em upload no bd
          if (this.novoLancamento.files.length > 0) {
            await this.uploadFile(lancamento.data)
          }
        } catch (err) {
          displayMessage('error', 'Erro!', err.message)
        }
      },
      async criarPagamento () {
        
        try {
          const pagamento = {
            tipo: this.novoLancamento.tipo_pg,
            qt_parcelas: "1",
            id_pedido: this.novoLancamento.id_pedido,
            itens: []
          }
          pagamento.itens.push({
            valor: this.novoLancamento.valor_total,
            forma_pagamento: this.novoLancamento.forma_pg,
            parcela: {
              total: 1,
              atual: 1,
            }
          })
          await pagamentoService.storePagamento(pagamento)
        } catch (err) {
          displayMessage('error', 'Erro!', err.message)
        }
        
      },
      async salvarLancamento () {
        this.btnSalvar = true
        //atualiza status do pagamento do lançamento caso seja despesa
        if (this.novoLancamento.tipo_lancamento === 'despesa') {
          this.novoLancamento.status_pg = 'concluido'
        }
  
        try {
          loader({text: 'Salvando lançamento', active: true})
          this.novoLancamento.valor_total = moneyToNumber(this.novoLancamento.valor_total)

          // caso o usuario tenha selecionado a forma de pagamento criamos o pedido como concluido e o pagamento
          if (this.novoLancamento.tipo_lancamento == 'receita' && this.novoLancamento.forma_pg) {
            this.novoLancamento.status_pg = 'pendente'
            await this.criarPedido()
            await this.criarLancamento()
            await this.criarPagamento()            
            this.$bvModal.hide('bv-modal-confirmacao-1')
            // Atualiza pedidos e saldo no store
            await this.atualizaPedidos()
            
            loader({active: false, text: null})
            displayMessage('success', 'Item lançado com sucesso! Ele poderá ser visualizado na lista de itens concluidos')     
            this.resetForm()
            return
          }
          if (this.novoLancamento.tipo_lancamento == 'receita') {
            this.novoLancamento.status_pg = 'pendente'
            await this.criarPedido()
          }

          await this.criarLancamento()

          this.$bvModal.hide('bv-modal-confirmacao-1')

          // Atualiza pedidos e saldo no store        
          this.atualizaPedidos()

          if (this.novoLancamento.status_pg === 'concluido') {
            displayMessage('success', 'Item lançado com sucesso! Ele poderá ser visualizado na lista de itens concluidos')          
          } else displayMessage('success', 'Lancamento cadastrado com sucesso, Ele poderá ser visualizado em itens pendentes')
          this.resetForm()

        } catch (error) {
          const message = getErrors(error)
          displayMessage('error', 'Erro!', message.message)
        } finally {
          this.btnSalvar = false
          loader({active: false, text: null})
        }        

      },
      async uploadFile (lancamento) {
        const files = this.novoLancamento.files
        files.forEach(file => {
          let form = new FormData()
          form.append('file', file)
          try {
            pedidoService.uploadFiles(form, lancamento.cx_lancamento_id)
          } catch (err) {
            console.log(err)
          }
        })
      },
      async atualizaPedidos () {
        this.$store.dispatch('frenteCaixa/atualizarPedidos')
      },
      getFiles (files) {
        this.novoLancamento.files = files
      },
      modalConfirmcao () {
        if (this.novoLancamento.forma_pg != null || this.novoLancamento.tipo_lancamento === 'despesa') {
          this.$bvModal.hide('novoLancamento')
          this.salvarLancamento()
        } else {
          this.$bvModal.hide('novoLancamento')
          this.$bvModal.show('bv-modal-confirmacao-1')
        }
      },
      modalConfirmacaoNao () {
        this.$bvModal.hide('bv-modal-confirmacao-1')
        this.$bvModal.show('novoLancamento')
      },
      async editarLancamento () {
        try {
          loader({text: 'Salvando alterações', active: true})
          const payload = {
            data_lancamento: moment(this.novoLancamento.data_lancamento).format('YYYY-MM-DD'),
            tipo_lancamento: this.novoLancamento.tipo_lancamento,
            beneficiario: this.novoLancamento.beneficiario,
            ato: this.novoLancamento.ato,
            detalhamento: this.novoLancamento.detalhamento,
            valor_total: this.novoLancamento.valor_total,
            id_lancamento: this.propPedido.lancamentosAvulso.cx_lancamento_id,
          }
          await lancamentoService.editarLancamentos(payload)
          // Renderiza pedidos atualizados
          this.$store.dispatch('frenteCaixa/atualizarPedidos')

          this.$bvModal.hide('novoLancamento')
          displayMessage('success', 'Edição realizada com sucesso')
        } catch (err) {

        } finally {
          loader({text: null, active: false})
        }
      },
      openModal () {
        this.resetForm()
      },
      resetForm () {
        if (this.propPedido) return
        Object.assign(this.$data, this.$options.data())
      },
    }
  })

</script>

<style scoped>
.label-obrigatoria {
  color: #8B0000;
}
.bv-modal-confirmacao {
  font-size: 24px;
}
.botao-modal {
  width: 100px;
}
</style>